import { IconsService } from '$services/icons/icons.service';
import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.css']
})
export class ActionsComponent {

  @Output() onSubmit: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>()
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>()

  constructor(
    private readonly icons: IconsService,
    private readonly router: Router,) {
    this.icons.registerIcon([`user`])
  }

  submit(e:MouseEvent){
    this.onSubmit.emit(e)
  }
  cancel(){
    this.onCancel.emit()
  }

  protected goToSignup(){
    this.router.navigate(['/signup']);
    this.cancel()
  }
}
